export default __webpack_public_path__ + "static/full_des_monitor-c18392f00d0b4ff0e499c07c5ff93a9c.svg";